import React from 'react';
import { motion } from 'framer-motion';

export const SkeletonBlock = ({ className, delay = 0 }) => (
  <div className={`relative overflow-hidden bg-white/5 ${className}`}>
    <motion.div
      initial={{ x: '-100%' }}
      animate={{ x: '100%' }}
      transition={{
        repeat: Infinity,
        duration: 1.4,
        ease: "linear",
        delay
      }}
      className="absolute inset-0 bg-gradient-to-r from-transparent via-white/[0.08] to-transparent"
    />
  </div>
);
